<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Additional Deductions"
      text="Create Additional Deductions"
      class="mb-0"
    >
      <form v-if="!loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="font-weight-bold">
                Tax Relief
              </div>
              <div>{{ taxRelief.name }}</div>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="amount"
                v-validate="'required'"
                v-money="money"
                label="Amount"
                :error-messages="errors.collect('amount')"     
                data-vv-name="amount"
                prefix="RM"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                max-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    v-validate="'required'"
                    :error-messages="errors.collect('date')"
                    data-vv-name="date"
                    data-vv-as="process date"
                    label="Process Date"
                    readonly
                    outlined
                    class="fix-date-picker-outline-overlap"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  type="month"
                  no-title
                  @input="dateMenu = false"
                />
              </v-menu> 
            </v-col> 
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="px-10"
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"     
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    directives: { money: VMoney },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployeeUid: {
        type: String,
        required: true,
      },
      taxRelief: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dateMenu: false,
        date: null,
        loading: false,
        progressing: false,
        dialog: false,
        amount: null,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData() 
        this.loading = true
      
        this.loading = false
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
          
            this.progressing = true

            this.$api.companyEmployeeAdditionalDeductions().create(this.companyEmployeeUid, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })
                
                this.progressing = false
                this.dialog = false
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          tax_relief_id: this.taxRelief.id,
          process_date: this.date + '-01',
          amount: this.amount.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>.

<style scoped>
.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px;
}
</style>
